import { createFeatureSelector, createSelector } from '@ngrx/store';
import { findUniversityFeatureKey, State } from '../reducers/find-university.reducer';

const selectFindUniversityState = createFeatureSelector<State>(findUniversityFeatureKey);

export const getFindUniversityResult = createSelector(selectFindUniversityState, state => state.result);
